import { ModalTitle } from '@components'
import cn from '@integrations/classnames'
import type { HTMLAttributes } from '@integrations/react'
import styles from './RequestModalSurface.module.scss'

type Props = HTMLAttributes<HTMLDivElement>

interface TitleProps extends HTMLAttributes<HTMLHeadingElement> {
  as?: 'div' | 'h3'
}

export function RequestModalSurface({ children, className, ...props }: Props) {
  return (
    <div className={cn(styles['request-modal-surface'], 'request-modal-surface', className)} {...props}>
      {children}
    </div>
  )
}

export function RequestModalTitle({ as: Component = 'div', children, className, ...props }: TitleProps) {
  return (
    <ModalTitle
      as={Component}
      className={cn(styles['request-modal-title'], 'request-modal-title', className)}
      {...props}
    >
      {children}
    </ModalTitle>
  )
}

export function RequestModalBody({ children, className, ...props }: Props) {
  return (
    <div className={cn(styles['request-modal-body'], 'request-modal-body', className)} {...props}>
      {children}
    </div>
  )
}
